/* eslint-disable */
// eslint-disable-next-line prettier/prettier
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable prettier/prettier */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { createContext, ReactChild, ReactFragment, ReactPortal, useState } from 'react'

export const CashmgmtContext = createContext<any>('')


export const CashmanagementProvider = (props:any) => {

  const [language, setLanguage] = useState('');
    const [data, setData] = useState('hello');
    const [totalCashBeingDroped, settotalCashBeingDroped] = useState(0);
    const [dropReconciliationData,setDropReconciliationData]=useState({});
    const [isReconciled,setIsRecociled] = useState(false);
    const [FindCountry,setFindCountry]=useState<string>();
    const [featureFlagDetails, setFeatureFlagDetails] = useState({});




  return (
    <CashmgmtContext.Provider

      value={{
        language,
        setLanguage,
        data,
        setData,
        settotalCashBeingDroped,
        totalCashBeingDroped,
        dropReconciliationData,
        setDropReconciliationData,
        isReconciled,
        setIsRecociled,
        FindCountry,
        setFindCountry,
        featureFlagDetails,
        setFeatureFlagDetails
      }}>
      {props.children}

    </CashmgmtContext.Provider>
    )
}
export function MakeFeatureFlagObjFn(storeValue: any) {
  const tempFeatureFlagObj: any = {};
  for (let i = 0; i < storeValue.length; i++) {
    tempFeatureFlagObj[storeValue[i].paramKeyName] = storeValue[i].paramValue;
  }
  console.log('tempFeatureFlagObj', tempFeatureFlagObj);
  return tempFeatureFlagObj;
}